import type { IPaginationResult } from '../../../models/pagination-result.model';
import type IPressRelease from '../../../models/press/press-release.model';
import PaginationResultApiModel from '../../../services/pagination-result.api-model';
import { PressReleaseApiModel } from './press-release.api-model';

export class PressReleasesApiModel {
  public static mapToBusinessModel(apiModel: PaginationResultApiModel<PressReleaseApiModel>): IPaginationResult<IPressRelease> {
    return {
      results: apiModel.results.map(PressReleaseApiModel.mapToBusinessModel),
      count: apiModel.count,
      totalCount: apiModel.totalCount,
      links: {
        current: apiModel.links?.current,
        next: apiModel.links?.next,
        previous: apiModel.links?.previous,
      },
    };
  }
}
